import { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'

import { resetPendingFitMap } from '@/map'
import { useAppDispatch } from '@/store'
import { selectPlaceMapStyles, updateMapStyle } from '@/features/domain/ui'
import { selectTerritoryId } from '@/features/domain/territory'

export function useEnsurePlaceVisibility() {
  const dispatch = useAppDispatch()

  const territoryId = useSelector(selectTerritoryId)

  // ATTENTION: this REF is intentionally created and not updated
  const rOriginalMapStyle = useRef(useSelector(selectPlaceMapStyles))

  useEffect(() => {
    // access previously active place Map Styles
    const originalMapStyle = rOriginalMapStyle.current

    // make place style visible
    dispatch(
      updateMapStyle({
        type: 'place',
        mode: 'on',
      }),
    )

    return () => {
      resetPendingFitMap()

      // restore previously active place Map Styles
      dispatch(
        updateMapStyle({
          type: 'place',
          mode: originalMapStyle.mode,
        }),
      )
    }
  }, [dispatch, territoryId])
}
